// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function CaretsOutVertical(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "CaretsOutVertical" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.5 9.75L4.5 9.75L12 1.5L19.5 9.75Z", fill: "currentColor" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 14.25L19.5 14.25L12 22.5L4.5 14.25Z", fill: "currentColor" }))));
});
//# sourceMappingURL=CaretsOutVertical.js.map